
export class NavLink {
  NavLinkId: number
  Title: string
  Url: string
  LinkText: string
  IconClass: string
  IconUrl: string
  LinkOrder: number
  NavLinkParentId: number
  CreatedBy: number
  CreatedDateTime: string
  UpdatedBy: number
  UpdatedDateTime: string
  IsDeleted: boolean
  Isdialogclosed: boolean
  Isdialog: boolean
  linkJson: string
  isAdmin: string
  source: any
}
export class NavTree {

  NavTreeId: number
  NavParentId: number
  NavChildId: number[]
  CreatedBy: number
  CreatedDateTime: string
  UpdatedBy: number
  UpdatedDateTime: string
  IsDeleted: boolean
  ChildId: number;
  Parentname: string
  Childname: string
  Isdialogclosed: boolean
  Isdialog: boolean

}
export class NavRoles {
  Id: string
  Name: string
  Description: string
  NormalizedName: string
  ConcurrencyStamp: string

}
export class NavRoleMapping {
  roleId: string
  NavLinkRoleId: number
  NavLinkId: number
  Navlinkmap: number[]
  Access: any
  Rolename: string
  Linkname: string
  RoleId: string
  CreatedBy: number
  CreatedDateTime: string
  UpdatedBy: number
  UpdatedDateTime: string
  IsDeleted: boolean
  Isdialogclosed: boolean
  Isdialog: boolean
  NavigationAccess:any
  navlinkmap: number[]
  OrderNo:number
}